import React, { useState } from 'react';
import { reportsAPI } from '../services/api';

const TestAPI = () => {
  const [testResults, setTestResults] = useState({});
  const [loading, setLoading] = useState(false);

  const runTests = async () => {
    setLoading(true);
    const results = {};
    
    try {
      // Test user-facing dashboard reports
      console.log('Testing user-facing dashboard reports...');
      results.bookings = await reportsAPI.getBookingsByCountry('2025-10-01', '2025-10-31');
      results.revenue = await reportsAPI.getRevenueByHotel('2025-10-01', '2025-10-31');
      results.trends = await reportsAPI.getBookingTrends('2025-10-01', '2025-10-31');
      results.demographics = await reportsAPI.getUserDemographics('2025-10-01', '2025-10-31');
      
      // Test with no date parameters
      console.log('Testing reports with no date parameters...');
      results.bookingsNoDates = await reportsAPI.getBookingsByCountry();
      results.revenueNoDates = await reportsAPI.getRevenueByHotel();
      results.trendsNoDates = await reportsAPI.getBookingTrends();
      results.demographicsNoDates = await reportsAPI.getUserDemographics();
      
      // Test admin overview endpoints
      console.log('Testing admin overview endpoints...');
      results.adminOverview = await reportsAPI.getAdminOverview();
      results.adminStats = await reportsAPI.getAdminStats();
      results.superAdminStats = await reportsAPI.getSuperAdminStats();
      
      // Test new visitor analytics endpoints
      console.log('Testing visitor analytics endpoints...');
      results.visitorAnalytics = await reportsAPI.getVisitorAnalytics({ period: 30 });
      results.visitorTrends = await reportsAPI.getVisitorTrends({ period: 30 });
    } catch (error) {
      console.error('Test error:', error);
      results.error = error.message;
    } finally {
      setLoading(false);
      setTestResults(results);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>API Test Results</h1>
      <button onClick={runTests} disabled={loading}>
        {loading ? 'Testing...' : 'Run Tests'}
      </button>
      
      {Object.keys(testResults).map(key => (
        <div key={key} style={{ margin: '20px 0', padding: '10px', border: '1px solid #ccc' }}>
          <h3>{key}</h3>
          <pre>{JSON.stringify(testResults[key], null, 2)}</pre>
        </div>
      ))}
    </div>
  );
};

export default TestAPI;